var controlMixin = {
    props: {
        isReadOnly: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        isEnabled: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        isVertical: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        label: {
            default: function () {
                return "";
            }
        },
        isFrontLabel: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        placeholder: {
            type: String,
            default: function () {
                return '';
            }
        },
        icon: {
            type: String,
            coerce: function (val) {
                if (!val || val.length === 0)
                    return '';
                return 'zmdi-' + val;
            },
            default: function () {
                return "";
            }
        }
    }

};
export default controlMixin;



// WEBPACK FOOTER //
// ./src/mixins/control-mixins.js